import { Box, Grid, TextField } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../helpers/Notification';
import { ButtonFile, EstatusField, LoadingWidget } from '../../../../widgets';
import {
  getFileUrl,
  saveArchivosAction,
} from '../../../archivos/ArchivosAction';
import { allDocentesAction } from '../../../control_estudios/docentes/DocentesAction';
import SelectFieldDocentesComponent from '../../../control_estudios/docentes/components/SelectFieldDocentes';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import SelectFieldDeportesComponent from '../../../sistema/deportes/components/SelectFieldDeportes';
import SelectFieldJugadoresComponent from '../../jugadores/components/SelectFieldJugadores';
import { saveEquiposAction } from '../EquiposAction';

const FormEquipos = ({ isPanel = false, setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const equiposStore = Redux.useSelector((state) => state.equipos);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const [fileImage, setFileImagen] = React.useState();

  const activo = equiposStore.activo;

  const initData = {
    nombre: '',
    desc: '',
    idLider: null,
    idImagen: null,
    idDeporte: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    idDeporte: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);
  const [entrenador, setEntrenador] = React.useState(null);

  function getDocente(isDocente, id) {
    let docente;

    if (isDocente) {
      docente = docentesStore.all.find((el) => el.id === id);
    } else {
      docente = docentesStore.all.find((el) => el.usuario.id === id);
    }

    return docente;
  }

  React.useEffect(() => {
    async function fetchData() {
      if (docentesStore.all && docentesStore.all.length === 0) {
        await allDocentesAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!activo) return;
    const fetchData = async () => {
      let values = {};
      Object.keys(data).map((key) => (values[key] = activo[key]));

      const findEntrenador = await getDocente(
        false,
        equiposStore.activo.entrenador?.id,
      );
      setEntrenador(findEntrenador);

      setTimeout(
        () =>
          setData({
            ...values,
            lider: activo?.lider?.id,
            idImagen: activo?.imagen?.id,
            idDeporte: equiposStore.activo.deporte.id,
            idEstatus: activo?.estatus.id ?? 1,
          }),
        300,
      );
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!data.idDeporte) {
      notify('Falta seleccionar un deporte', { warning: true });
      return;
    }
    if (!entrenador) {
      notify('Falta seleccionar un entrenador', { warning: true });
      return;
    }
    if (!fileImage && !activo) {
      notify('Falta seleccionar una imagén para el equipo', { warning: true });
      return;
    }

    if (_validDataForm()) {
      setLoadingSave(true);

      let res;

      if (fileImage) {
        const resImagen = await saveArchivosAction(dispatch, {
          file: fileImage,
          isPublic: 't',
          desc: 'Foto de equipo',
        });
        res = await saveEquiposAction(
          { dispatch, notify },
          activo?.id,
          {
            ...data,
            idEntrenador: entrenador?.usuario.id,
            idImagen: resImagen.id,
            idEntidad: entidadesStore.activo.id,
          },
          equiposStore.params,
        );
      } else {
        if (!activo.imagen) {
          notify('Falta seleccionar una imagen', { warning: true });
        }
      }

      if (activo) {
        res = await saveEquiposAction(
          { dispatch, notify },
          activo.id,
          {
            ...data,
            idEntrenador: entrenador?.usuario.id,
            idEntidad: entidadesStore.activo.id,
          },
          equiposStore.params,
        );
      }

      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <ButtonFile
            onFile={(file) => setFileImagen(file)}
            file={fileImage}
            text="Subir imagén del equipo"
            sxc={{ marginTop: '5px' }}
            size="50%"
            name={activo?.imagen?.nombre}
            onDelete={() => setFileImagen(null)}
            src={!fileImage && getFileUrl(activo?.imagen)}
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <Grid container spacing={2}>
            {loadingSave && (
              <Grid item xs={12} md={12}>
                <LoadingWidget isLoading={loadingSave} isActivo={activo} />
              </Grid>
            )}

            <Grid item xs={12} md={12}>
              <SelectFieldDeportesComponent
                value={data.idDeporte}
                required
                onChange={(idDeporte) =>
                  _handleSetDataField(CONST.deporte.idName, idDeporte)
                }
              />
            </Grid>

            <Grid item xs={12} md={isPanel ? 6 : 12}>
              <SelectFieldDocentesComponent
                value={entrenador?.id ?? ''}
                label={CONST.entrenador.label}
                required
                isAll={false}
                onChange={(idDocente) => {
                  setEntrenador(getDocente(true, idDocente));
                }}
              />
            </Grid>

            {isPanel && (
              <Grid item xs={12} md={6}>
                <SelectFieldJugadoresComponent
                  value={data.idLider}
                  label="Líder del equipo"
                  required
                  isAll={false}
                  onChange={(idJugador) => {
                    _handleSetDataField(CONST.lider.idName, idJugador);
                  }}
                />
              </Grid>
            )}

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                id={CONST.nombre.name}
                required
                label={CONST.nombre.label}
                value={data.nombre}
                onChange={(e) =>
                  _handleSetDataField(
                    CONST.nombre.name,
                    e.target.value.toUpperCase(),
                  )
                }
                helperText={dataError.nombre ? validMessage.required : null}
                error={dataError.nombre}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <EstatusField
                value={data.idEstatus}
                onChange={(e) =>
                  _handleSetDataField(CONST.estatus.idName, e.target.value)
                }
                isEstatus
                required
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                size="small"
                id={CONST.desc.name}
                label={CONST.desc.label}
                value={data.desc}
                multiline
                rows={2}
                onChange={(e) =>
                  _handleSetDataField(CONST.desc.name, e.target.value)
                }
                helperText={dataError.desc ? validMessage.required : null}
                error={dataError.desc}
              />
            </Grid>

            <Grid item xs={12} md={12} align="center">
              <BotonComponent
                click={_handleSubmit}
                text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
                disabled={loadingSave}
                green={!activo}
                blue={activo}
                saveIcon
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormEquipos;
